<template>
    <div class="solution-preview">
        <slidePreview
            v-bind:curentSolution="curentSolution"
            v-bind:curentEnvironment="curentEnvironment"
            v-on:selectSlideSolution="selectSlideSolution"
        />

        <div class="preview-detail"
            v-if="curentSolution.environment_specific_use"
        >
            <h4>{{curentSolution.hotspot}}</h4>
            <div class="detail">
                <div class="description">
                    {{curentSolution.environment_specific_use}}
                </div>
                <div class="image">

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import slidePreview from '@/components/system/slide-preview.vue'

    export default {
        name: "SolutionPreview",
        props: ['curentSolution', 'curentEnvironment'],
        data() {
            return {}
        },
        watch: {
        },
        methods:{
            selectSlideSolution(sol_id){
                this.$emit('solutionActivate', sol_id);
            }
        },
        components: {
            slidePreview
        }
    }
</script>

<style lang="scss" scoped>

</style>